<template>
    <div>
        <loading-progress-bar v-if="loading" :loading="loading" color="secondary"></loading-progress-bar>
        <v-layout v-if="!loading" row wrap>
            <v-flex xs12>
                <vue-plotly v-if="data" :white-mode="whiteMode" :data="data"
                            :layout="layout" :options="{}" @click="handleClick"/>
            </v-flex>
        </v-layout>
    </div>
</template>

<script>
import {getNotification} from '@/helper'
import LoadingProgressBar from './../LoadingProgressBar'
import VuePlotly from "./../VuePlotly";

export default {
    props: {
        title: {type: String, default: "Notification Summary"},
        facet: {type: String, default: "equipment_type"},
        height: {type: Number, default: 300},
        limit: {type: Number, default: 10},
        dateRange: {type: Object, default: null},
        whiteMode: {type: Boolean, default: false},
    },
    components: {LoadingProgressBar, VuePlotly},
    computed: {},
    name: 'NotifBreakdownWidget',
    watch: {
        dateRange() {
            this.refresh()
        },
    },
    data: function () {
        return {
            loading: true,
            timeout: null,
            data: null,
            layout: null

        }
    },
    mounted() {
        this.refresh()
    },
    methods: {
        debounce(callback, wait) {
            clearTimeout(this.timeout);
            this.timeout = setTimeout(() => callback(), wait);
        },
        refresh() {
            this.debounce(this.getData, 500);
        },
        handleClick(data) {
            let facet = data.points[0].fullData.name
            let value = data.points[0].y
            let filters = {
                rangeStart: this.dateRange.start,
                rangeEnd: this.dateRange.end,
            }
            filters[facet] = value
            this.$router.push({
                path: '/notification-breakdown',
                query: filters
            }).catch(err => {
            })
        },
        async getData() {
            if (this.dateRange) {
                this.loading = true
                this.data = null
                let notifs = await getNotification({
                    facility_name: this.$store.state.pointsListStore.pointsList.facility_name,
                    date_range: [this.dateRange.start, this.dateRange.end],
                })
                let facetObj = {}
                for (let notif of notifs.result) {
                    if (!facetObj[notif[this.facet]]) {
                        facetObj[notif[this.facet]] = 1;
                    } else {
                        facetObj[notif[this.facet]] += 1;
                    }
                }
                if (Object.keys(facetObj).length >= 1) {
                    let sorted = Object.keys(facetObj).sort(function (a, b) {
                        return facetObj[b] - facetObj[a]
                    })
                    let top10 = sorted.slice(0, this.limit);
                    let top10Scores = []
                    for (let top of top10) {
                        top10Scores.push(facetObj[top])
                    }
                    this.data = [{
                        type: 'bar',
                        name: this.facet,
                        x: top10Scores.reverse(),
                        y: top10.reverse(),
                        orientation: 'h',
                    }]
                    this.layout = {
                        title: this.title,
                        height: this.height,
                        margin: {
                            "l": 50,
                            "r": 50,
                            "t": 50,
                            "pad": 1
                        },
                        xaxis: {'automargin': true, 'tickformat': ',d'},
                        yaxis: {'automargin': true},
                    }
                }
                this.loading = false
            }
        }
    },
}
</script>
